/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import canUseDom from '~/utils/dom/canUseDom';
import isUnavail from '@dcode/is/unavail/unavail';
import isAvail from '@dcode/is/avail/avail';
import Img from './Img';

const classes = {
};

const propTypes = {
	className: PropTypes.string,
	classNameImg: PropTypes.string,
	src: PropTypes.string,
	alt: PropTypes.string,
	sizes: PropTypes.string,
	sources: PropTypes.arrayOf(
		PropTypes.exact({
			srcSet: PropTypes.string.isRequired,
			media: PropTypes.string,
			type: PropTypes.string,
		}),
	),
};

const defaultProps = {
	className: '',
	classNameImg: '',
	classes,
	src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
	alt: '',
	sizes: undefined,
	sources: undefined,
};

export const Picture = ({
	className,
	classes,
	classNameImg,
	sources,
	sizes,
	src,
	alt,
	...props
}) => {
	const renderSources = () => {
		let ieVersion = -1;
		if (canUseDom && document.documentMode) {
			ieVersion = document.documentMode;
		}
		if (isUnavail(sources)) return null;
		const mappedSources = sources.map((source, index) => {
			if (isUnavail(source.srcSet)) return null;
			return <source key={`sources-${index}`} srcSet={source.srcSet} media={source.media} type={source.type} />;
		});
		if (ieVersion === 9) {
			return <video style={{ display: 'none' }}>{mappedSources}</video>;
		}
		return mappedSources;
	}

	const renderImage = (skipSizes = false) => {
		return (
			<Img
				alt={alt}
				src={src}
				{...(skipSizes ? null : { sizes })}
				{...props}
				className={classNameImg}
			/>
		);
	};

	const renderPicture = () => {
		return (
			<picture className={className}>
				{renderSources()}
				{renderImage(true)}
			</picture>
		);
	};

	React.useEffect(() => {
		try {
			require('picturefill')(); // eslint-disable-line global-require
		} catch (error) {}
	}, []);

	return isAvail(sources)
		? renderPicture()
		: renderImage()
	;
}

Picture.displayName = 'Picture';
Picture.propTypes = propTypes;
Picture.defaultProps = defaultProps;
export default React.memo(Picture);
